import { render, staticRenderFns } from "./AnswerRacerStudent.vue?vue&type=template&id=07f9500e"
import script from "./AnswerRacerStudent.vue?vue&type=script&lang=js"
export * from "./AnswerRacerStudent.vue?vue&type=script&lang=js"
import style0 from "./AnswerRacerStudent.vue?vue&type=style&index=0&id=07f9500e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports